import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";

type ResultRow = {
    subject: string;
    maxMarks: number;
    marksObtained: number;
    percentage: number;
};

interface ExamResultProps {
    entityId: string;
    onBack: () => void;
}

const ExamResult: React.FC<ExamResultProps> = ({
    entityId,
    onBack
}) => {
    const [results, setResults] = useState<ResultRow[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadResults();
    }, [entityId]);

    const loadResults = async () => {
        if (!entityId) return;

        try {
            setLoading(true);

            const response = await serviceApi.get<any>(
                `${environment.examresult}?entityId=${encodeURIComponent(
                    entityId
                )}`
            );

            if (response?.status === "SUCCESS") {
                const formatted =
                    (response?.dataList || []).map((item: any) => ({
                        subject: item.subject,
                        maxMarks: Number(item.maxMarks),
                        marksObtained: Number(item.mrks),
                        percentage: Math.round(
                            (Number(item.mrks) /
                                Number(item.maxMarks)) *
                            100
                        )
                    }));

                setResults(formatted);
            } else {
                setResults([]);
            }
        } catch (error) {
            console.error("Exam Result Error:", error);
            setResults([]);
        } finally {
            setLoading(false);
        }
    };

    const getChartColor = (index: number) => {
        const colors = [
            "#4bc0c0",
            "#36a2eb",
            "#9966ff",
            "#ff9f40",
            "#4bc0c0",
            "#36a2eb"
        ];

        return colors[index % colors.length];
    };
    return (
        <>
            <div
                style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "35px 12px 15px 12px",
                    minHeight: "40px"
                }}
            >
                <button
                    onClick={onBack}
                    style={{
                        position: "absolute",
                        left: "12px",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "var(--colorPrimaryDark)",
                        padding: 0,
                        margin: 0
                    }}
                >
                    ← Back
                </button>

                <h2
                    className="title-text notification-heading"
                    style={{
                        margin: 0,
                        textAlign: "center"
                    }}
                >
                    Exam Results
                </h2>
            </div>

            {loading && (
                <div className="loading-overlay">
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">
                            Loading Results...
                        </span>
                    </div>
                </div>
            )}

            {!loading && (
                <>
                    {results.length > 0 ? (
                        <div
                            className="event-container"
                            style={{
                                marginTop: "12px",
                                padding: "15px"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-around",
                                    alignItems: "flex-start",
                                    flexWrap: "wrap",
                                    gap: "20px",
                                    marginBottom: "20px"
                                }}
                            >
                                {results.map((row, idx) => {
                                    const color = getChartColor(idx);

                                    return (
                                        <div
                                            key={idx}
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                minWidth: "80px"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "60px",
                                                    height: "60px",
                                                    borderRadius: "50%",
                                                    background: `conic-gradient(
                                            ${color} ${row.percentage}%,
                                            #e5e5e5 ${row.percentage}% 100%
                                        )`,
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "42px",
                                                        height: "42px",
                                                        borderRadius: "50%",
                                                        background: "#fff",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        fontSize: "11px",
                                                        fontWeight: 700
                                                    }}
                                                >
                                                    {row.percentage}%
                                                </div>
                                            </div>

                                            <div
                                                style={{
                                                    marginTop: "8px",
                                                    fontSize: "11px",
                                                    fontWeight: 700,
                                                    textAlign: "center"
                                                }}
                                            >
                                                {row.subject.toUpperCase()}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            {results.map((row, idx) => (
                                <div key={idx}>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            padding: "12px 0"
                                        }}
                                    >
                                        <div>
                                            <div
                                                style={{
                                                    fontSize: "18px",
                                                    fontWeight: 700,
                                                    color: "#f04d3d",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                {row.subject.toUpperCase()}
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        color: "#f04d3d",
                                                        fontWeight: 700
                                                    }}
                                                >
                                                    Max Marks :
                                                </span>{" "}
                                                {row.maxMarks}
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                textAlign: "right"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "22px",
                                                    fontWeight: 700,
                                                    color: "#f04d3d"
                                                }}
                                            >
                                                {row.percentage}%
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: 700,
                                                    color: "green"
                                                }}
                                            >
                                                Obtained Marks :
                                                <span
                                                    style={{
                                                        color: "#333",
                                                        fontWeight: 400
                                                    }}
                                                >
                                                    {" "}
                                                    {row.marksObtained}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {idx !== results.length - 1 && (
                                        <hr
                                            style={{
                                                border: "none",
                                                borderTop: "1px dashed #888",
                                                margin: "0"
                                            }}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="event-container">
                            <div
                                style={{
                                    textAlign: "center",
                                    color: "#777"
                                }}
                            >
                                Results not yet announced
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default ExamResult;